export const headers = [
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Tipo', field: 'type', sortable: false },
  { name: 'Controlador', field: 'controller', sortable: false },
  { name: 'Método', field: 'method', sortable: false },
  { name: 'Ação', field: 'action', sortable: false },
  { name: 'Ações', field: 'actions', sortable: false }
]
